'use strict';
angular.module('reporting.dashboards.services').factory('containerEvents', [
    '$rootScope',
    'rsEnvironment',
    function ($rootScope, rsEnvironment) {
        return {
            toggleSidebar: function () {
                $rootScope.$broadcast('toggleSidebar');
            },
            toggleEditing: function (startEditing, saveChanges) {
                if (startEditing) {
                    rsEnvironment.set('editing', true);
                    $rootScope.$broadcast('toggledEditing', true);
                }
                else {
                    $rootScope.$broadcast('toggledEditing', false, saveChanges);
                }
            },
            saveChanges: function () {
                $rootScope.$broadcast('saveChanges');
            },
            revertChanges: function () {
                $rootScope.$broadcast('revertChanges');
            }
        };
    }
]);
